/* eslint-disable */
import React from "react";
import ReactECharts from "echarts-for-react";
import "./styles.scss";
import { history } from "../../../config/stores";

const SubscriptionPie = ({ data, colors, title, context = "users" }) => {
  const handleInfoClick = (type, count) => {
    // Only navigate if count is greater than 0
    if (count > 0) {
      // Navigate to different routes based on context and subscription type
      if (context === "communities") {
        history.push(`/dashboard/communities/${type.toLowerCase()}`);
      } else {
        history.push(`/dashboard/subscriptions/${type.toLowerCase()}`);
      }
    }
  };

  const getEChartsOption = () => ({
    color: colors,
    series: [
      {
        type: "pie",
        radius: ["55%", "80%"],
        center: ["50%", "50%"], // Center the pie properly within its container
        data: data?.map(({ value, label }) => ({
          value: label,
          name: value,
        })),
        label: {
          show: false, // Remove default labels
        },
        labelLine: {
          show: false, // Remove lines from pie to labels
        },
      },
    ],
    legend: {
      show: false, // Disable default legend, we'll create custom
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
      position: function (point, params, dom, rect, size) {
        // Position tooltip to the right of the mouse cursor
        return [point[0] + 15, point[1]];
      },
    },
  });

  return (
    <div className="subscription-pie-container">
      <div className="subscription-pie-chart-section">
        {/* Pie Chart */}
        <div className="pie-chart-wrapper">
          <ReactECharts
            style={{ height: "200px", width: "200px" }}
            option={getEChartsOption()}
          />
        </div>

        {/* Custom Legend */}
        <div className="custom-legend">
          {data?.map((item, index) => (
            <div key={index} className="legend-item">
              <div className="legend-content">
                <div 
                  className="legend-line" 
                  style={{ backgroundColor: colors[index] }}
                />
                <span className="legend-number">{item.label}</span>
                <span className="legend-text">{item.value}</span>
              </div>
              <div
                className={`legend-info-icon ${item.label === 0 ? 'disabled' : ''}`}
                onClick={() => handleInfoClick(item.value, item.label)}
                style={{
                  opacity: item.label === 0 ? 0.3 : 1,
                  cursor: item.label === 0 ? 'not-allowed' : 'pointer'
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPie;
